import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusUpdateContactInfo00Table: GenericTableSchemaInterface = {
  id: "fms-plus-update-contact-info-00",
  name: "FMS+ Update Contact Info 00",
  description: "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Update Contact Info workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "6 months since the last time we asked SMS"
    },
    c05: {
      name: "7 day follow-up SMS"
    },
    c06: {
      name: "6 months since the last time we asked Email"
    },
    c07: {
      name: "7 day follow-up Email"
    }
  }
};
